"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RadioButton;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
function RadioButton(props) {
  var _props$value;
  var onChange = function onChange(event, checked) {
    props.onChange(checked);
  };
  return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    id: props.id,
    onChange: onChange,
    label: props.label,
    control: /*#__PURE__*/_react.default.createElement(_material.Radio, {
      id: 'radio-' + props.id,
      color: "primary",
      checked: (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : false
    })
  });
}